// extracted by mini-css-extract-plugin
export var activityContainer = "_lj-0";
export var typingIndicatorContainer = "_lj-1";
export var typingIndicatorDot = "_lj-2";
export var wave = "_lj-3";